/* ============================================================
   DIASPORA CALLING! — Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ---- COUNTDOWN TIMER ---- */
  function initCountdown() {
    var cdDays  = document.getElementById('cd-days');
    var cdHours = document.getElementById('cd-hours');
    var cdMins  = document.getElementById('cd-mins');
    var cdSecs  = document.getElementById('cd-secs');

    if (!cdDays) return;

    // Event date: Friday 7 August 2026, 3pm UTC (4pm BST)
    var target = new Date('2026-08-07T15:00:00Z').getTime();

    function pad(n, len) {
      return String(n).padStart(len || 2, '0');
    }

    function update() {
      var diff = target - Date.now();

      if (diff <= 0) {
        cdDays.textContent  = '000';
        cdHours.textContent = '00';
        cdMins.textContent  = '00';
        cdSecs.textContent  = '00';
        return;
      }

      cdDays.textContent  = pad(Math.floor(diff / 864e5), 3);
      cdHours.textContent = pad(Math.floor(diff % 864e5 / 36e5));
      cdMins.textContent  = pad(Math.floor(diff % 36e5  / 6e4));
      cdSecs.textContent  = pad(Math.floor(diff % 6e4   / 1e3));
    }

    update();
    setInterval(update, 1000);
  }

  /* ---- INTERSECTION OBSERVER — REVEAL ANIMATIONS ----
     Adds .is-visible (not .visible) to match all section
     styles in theme.css and the new section liquid files.
     Both class names are handled so any legacy .visible
     references still work during a phased rollout.
  ---- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything immediately
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('is-visible');
        el.classList.add('visible'); // legacy
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.classList.add('visible'); // legacy alias — harmless
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- SMOOTH ANCHOR SCROLL ----
     Offsets for the sticky header height (64px).
     Handles both hash links and in-page anchor buttons.
  ---- */
  function initSmoothScroll() {
    var NAV_HEIGHT = 64;

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href').slice(1);
      if (!id) return;

      var target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();

      var top = target.getBoundingClientRect().top + window.scrollY - NAV_HEIGHT - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  /* ---- TICKER PAUSE ON HOVER ---- */
  function initTicker() {
    var ticker = document.querySelector('.ticker');
    if (!ticker) return;

    var wrap = ticker.closest('.ticker-wrap');
    if (!wrap) return;

    wrap.addEventListener('mouseenter', function () {
      ticker.style.animationPlayState = 'paused';
    });
    wrap.addEventListener('mouseleave', function () {
      ticker.style.animationPlayState = 'running';
    });
  }

  /* ---- INIT ---- */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initReveal();
    initSmoothScroll();
    initTicker();
  });

})();